// extracted by mini-css-extract-plugin
export default {"container":"authAppRedirect_container__Cygla","text":"authAppRedirect_text__X5VVW","btn":"authAppRedirect_btn__wv+x6"};